export const MINUTES_PER_DAY = 1440
export const MINUTES_PER_WEEK = 10080
